import React, { useState } from "react";
import "./LoginForm.css";
import TextFieldInput from "../../../Atoms/Inputs/TextField/TextFieldInput";
import { Formik } from "formik";
import * as Yup from "yup";
import useLogin from "../../../../Hooks/useLogin";
import { loginURL } from "../../../../Hooks/URL";
import { PulseLoader } from "react-spinners";

const LoginSchema = Yup.object().shape({
  email: Yup.string().email("Invalid email !!").required("Email required !!"),
  password: Yup.string()
    .min(8, "Password is too short !!")
    .required("Password required !!"),
});

function LoginForm() {
  const [newObject, setNewObject] = useState({});
  const [goSave, setGoSave] = useState(false);
  const { saveState, loading } = useLogin({
    url: loginURL,
    goSave,
    setGoSave,
    newObject,
  });

  return (
    <div className="FormWrapper">
      <Formik
        initialValues={{ email: "", password: "" }}
        validationSchema={LoginSchema}
        onSubmit={(values) => {
          setNewObject(values);
          setGoSave(true);
        }}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
        }) => (
          <form
            className="LoginFormContainer"
            autoComplete="off"
            onSubmit={handleSubmit}
          >
            <div>
              <TextFieldInput
                fullWidth
                name="email"
                type="email"
                placeholder={"Enter your email"}
                className="LoginInput"
                label="Email"
                change={handleChange}
                blur={handleBlur}
                newValue={values.email}
              />
              {errors.email && touched.email && errors.email && (
                <p className="error">
                  {errors.email && touched.email && errors.email}
                </p>
              )}
            </div>
            <div>
              <TextFieldInput
                fullWidth
                name="password"
                type="password"
                placeholder={"Enter your password"}
                className="LoginInput"
                label="Password"
                change={handleChange}
                blur={handleBlur}
                newValue={values.password}
              />
              {errors.password && touched.password && errors.password && (
                <p className="error">
                  {errors.password && touched.password && errors.password}
                </p>
              )}
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "center",
                width: "100%",
              }}
            >
              <button
                className="actionButton primary addButton"
                onClick={handleSubmit}
                disabled={loading}
              >
                {loading ? <PulseLoader color="white" size={8} /> : "Login"}
              </button>
            </div>
          </form>
        )}
      </Formik>
    </div>
  );
}

export default LoginForm;
